module.exports = __webpack_public_path__ + "img/baby-breech-frank.38928fce.png";